var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191895,
    y: 0.902344,
    width: 21.8003,
    height: 16.1945,
    rx: 4,
    fill: "#ff4f4f"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.191895,
    y: 0.902344,
    width: 21.8003,
    height: 16.1945,
    rx: 4,
    fill: "#ff4f4f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.942383 14.7593V17.9396H11.0936V14.7593H-0.942383ZM10.5823 17.4283H-0.431083V15.2706H10.5823V17.4283Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.942383 14.7593V17.9396H11.0936V14.7593H-0.942383ZM10.5823 17.4283H-0.431083V15.2706H10.5823V17.4283Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 14.7593V17.9396H23.1298V14.7593H11.0938ZM22.6185 17.4283H11.6051V15.2706H22.6185V17.4283Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0938 14.7593V17.9396H23.1298V14.7593H11.0938ZM22.6185 17.4283H11.6051V15.2706H22.6185V17.4283Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.941895 0.0600586V3.24035H11.0941V0.0600586H-0.941895ZM10.5828 2.72905H-0.430594V0.571359H10.5828V2.72905Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.941895 0.0600586V3.24035H11.0941V0.0600586H-0.941895ZM10.5828 2.72905H-0.430594V0.571359H10.5828V2.72905Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 0.0595703V3.23986H23.1298V0.0595703H11.0938ZM22.6185 2.72856H11.6051V0.570871H22.6185V2.72856Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0938 0.0595703V3.23986H23.1298V0.0595703H11.0938ZM22.6185 2.72856H11.6051V0.570871H22.6185V2.72856Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46143 3.23975V14.7593H15.7262V3.23975H6.46143ZM15.2149 14.248H6.97273V3.75105H15.2149V14.248Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46143 3.23975V14.7593H15.7262V3.23975H6.46143ZM15.2149 14.248H6.97273V3.75105H15.2149V14.248Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.942383 3.23975V8.99699H6.46124V3.23975H-0.942383ZM5.94994 8.48569H-0.431083V3.75105H5.94994V8.48569Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.942383 3.23975V8.99699H6.46124V3.23975H-0.942383ZM5.94994 8.48569H-0.431083V3.75105H5.94994V8.48569Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7261 3.23975V8.99699H23.1297V3.23975H15.7261ZM22.6184 8.48569H16.2374V3.75105H22.6184V8.48569Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7261 3.23975V8.99699H23.1297V3.23975H15.7261ZM22.6184 8.48569H16.2374V3.75105H22.6184V8.48569Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.942383 8.99707V14.7594H6.46124V8.99707H-0.942383ZM5.94994 14.2481H-0.431083V9.50837H5.94994V14.2481Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.942383 8.99707V14.7594H6.46124V8.99707H-0.942383ZM5.94994 14.2481H-0.431083V9.50837H5.94994V14.2481Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7261 8.99707V14.7594H23.1297V8.99707H15.7261ZM22.6184 14.2481H16.2374V9.50837H22.6184V14.2481Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7261 8.99707V14.7594H23.1297V8.99707H15.7261ZM22.6184 14.2481H16.2374V9.50837H22.6184V14.2481Z",
    fill: "#DFDFDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIcon);
export default __webpack_public_path__ + "static/media/ccIcon.dd9866907a6e1be81d93d4cfae2c4bed.svg";
export { ForwardRef as ReactComponent };